import { render } from "./TeamComponent.vue?vue&type=template&id=900306f8&scoped=true"
import script from "./TeamComponent.vue?vue&type=script&lang=js"
export * from "./TeamComponent.vue?vue&type=script&lang=js"

import "./TeamComponent.vue?vue&type=style&index=0&id=900306f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-900306f8"]])

export default __exports__